/** Site search
 this function is redunt because it is much better to detect OS from php
 @see os_client_detector()
 TODO: delete this solution in feature versions
 */
const siteHelper = function() {

    // eslint-disable-next-line yoda
    if ( navigator.userAgent.indexOf( 'Linux' ) !== -1 ) {
        document.getElementsByTagName( 'html' )[0].classList.add( 'linux' );
    }
    // eslint-disable-next-line yoda
    if ( navigator.userAgent.indexOf( 'Mac OS' ) !== -1 ) {
        document.getElementsByTagName( 'html' )[0].classList.add( 'mac-os', 'linux' );
    }
};

// Export
export { siteHelper };
